<template>
  <v-data-table :headers="headers" :items="changeLog" :items-per-page-text="rowsPerPageText"
    :items-per-page.sync="paginationChangeLog.rowsPerPage" :items-per-page-items="rowsPerPageItems"
    :header-props="{ sortIcon }" :footer-props="{ prevIcon, nextIcon, 'items-per-page-options': rowsPerPageItems }"
    :loading="loading" loading-text=""
    @pagination="setRowsOnLocalStorage(dataTableChangeLogId, paginationChangeLog.rowsPerPage)">
    <template v-slot:item="props">
      <tr>
        <td>
          {{ getFormattedDate(props.item.updated_at) }}
        </td>

        <td>
          {{ getUserCauserName(props.item.causer_user) }}
        </td>

        <td>
          {{ props.item.description }}
        </td>

        <td>
          {{ props.item.attribute }}
        </td>

        <td>
          {{ props.item.oldValue ? props.item.oldValue : "" }}
        </td>

        <td>
          {{ props.item.newValue }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from "vuex";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
export default {
  name: "ChangeLogDataTable",

  mixins: [managementDatatableMixin],

  props: {
    height: {
      type: Number
    },

    width: {
      type: Number
    }
  },

  data() {
    return {
      loading: true,
      changeLog: [],
      userOptions: [],

      dataTableChangeLogId: "dataTableChangeLogId",
      paginationChangeLog: {
        rowsPerPage: this.getRowsFromLocalStorage("dataTableChangeLogId")
      },
    };
  },

  computed: {
    headers() {
      return [
        { text: this.$i18n.t("Date"), align: "left", value: "updated_at" },
        {
          text: this.$i18n.tc("User", 1),
          align: "left",
          value: "causer_user"
        },
        {
          text: this.$i18n.t("RequestType"),
          align: "left",
          value: "description"
        },
        {
          text: this.$i18n.tc("Attribute", 1),
          align: "left",
          value: "attributes"
        },
        {
          text: this.$i18n.t("OldValue"),
          align: "left",
          value: "old_value"
        },
        {
          text: this.$i18n.t("NewValue"),
          align: "left",
          value: "new_value"
        }
      ];
    },

    objectIdentifiers() {
      return this.$store.getters.selectedObjectIdentifiers;
    }
  },

  mounted() {
    this.getChangeLog();
  },

  methods: {
    ...mapActions(["getChangeLogByObjectUUID", "fetchAllUsers"]),

    async getChangeLog() {
      try {
        let changeLog = await this.getChangeLogByObjectUUID({
          objectUUID: this.objectIdentifiers.uuid,
          layer: this.objectIdentifiers.layerName
        });
        this.formatChangeLogs(changeLog.data.data);
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },

    formatChangeLogs(data) {
      let changeLogs = [];
      data.forEach(entry => {
        for (const [attribute, newValue] of Object.entries(
          entry.properties.attributes
        )) {
          if (
            attribute !== "updated_at" &&
            attribute !== "uuid" &&
            attribute !== "id"
          ) {
            let changeLog = {
              updated_at: entry.properties.attributes.updated_at,
              causer_user: entry.causer_user,
              description: entry.description,
              attribute: attribute,
              newValue: newValue
            };
            if (entry.description !== "created") {
              if (newValue !== entry.properties.old[attribute]) {
                changeLog.oldValue = entry.properties.old[attribute];
                changeLogs.push(changeLog);
              }
            } else if (newValue) {
              changeLogs.push(changeLog);
            }
          }
        }
      });
      this.changeLog = changeLogs;
      this.loading = false;
    },

    getUserCauserName(user) {
      let name = user.first_name;
      if (user.last_name) {
        name += " " + user.last_name;
      }
      return name;
    },

    getFormattedDate(isoDateTime) {
      if (isoDateTime) {
        let datetime = new Date(isoDateTime);
        return datetime.toLocaleString("pt-PT", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        });
      }
      return "—";
    }
  }
};
</script>

<style scoped>
table .v-table thead tr {
  height: 40px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/ChangeLogForm/ChangeLogDataTable.vue